import React from "react";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import NavBar from "./Component/NavBar";


const Contactus = () => {




    return (
        <>
            <Header />
            <div className="w-100">
                <NavBar />
                <div className="row">
                    <div className="col text-center">
                        <div className="TabTitle text-center mt-4">
                            <b className="my_title fs-3">Contactus</b>
                        </div>
                    </div>
                </div>
                <div className="text-center">
                    <h1 className="text-warning">Modern Convent</h1>
                    <h1 className="text-warning">Modern Coaching Center</h1>
                    <h2 className="text-warning">Govind Chak Sonpur</h2>
                    <h3 className="text-warning">Sonpur ,Saran,Bihar</h3>
                    <h1 className="text-warning">Contact Detail's:-</h1>
                    <h3 className="text-warning">Mobile No:- 9852888277,6204887570,8804302680</h3>
                    <h3 className="text-warning">Email:-modernconventandcoaching@gmail.com</h3>
                </div>
            </div>
            <Footer />
        </>
    );
};
export default Contactus;